export default __webpack_public_path__ + "static/media/archlinux.cc9458fd.svg";